import React from 'react';
import { MonitorSmartphoneIcon, MessageSquareIcon, BarChart4Icon, LayoutDashboardIcon } from 'lucide-react';
export const TechnologyAdvantage = () => {
  return <section id="technology" className="py-24 bg-gradient-to-b from-gray-50 to-gray-100 relative overflow-hidden" data-id="element-679">
      {/* Subtle pattern background */}
      <div className="absolute inset-0 opacity-10" data-id="element-680">
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" data-id="element-681">
          <defs data-id="element-682">
            <pattern id="tech-pattern" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-683">
              <path d="M0 20h40M20 0v40" stroke="#807c6a" strokeWidth="0.5" fill="none" data-id="element-684" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#tech-pattern)" data-id="element-685" />
        </svg>
      </div>
      <div className="container mx-auto px-6 relative z-10" data-id="element-686">
        <div className="text-center mb-16" data-id="element-687">
          <div className="inline-block mb-4" data-id="element-688">
            <span className="inline-block px-4 py-1 bg-limestone-200 text-limestone-700 rounded-full text-sm font-medium" data-id="element-689">
              CUTTING-EDGE TOOLS
            </span>
          </div>
          <h2 className="text-5xl font-serif font-bold mb-6 text-gray-800 tracking-tight leading-tight" data-id="element-690">
            Our Technology Advantage
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-light" data-id="element-691">
            Leverage cutting-edge technology designed specifically for luxury
            wedding planners.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-692">
          {/* Mobile App Card */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden transform transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl flex flex-col h-full" data-id="element-693">
            <div className="p-8 flex items-start gap-6" data-id="element-694">
              <div className="shrink-0 w-16 h-16 bg-gray-100 rounded-xl flex items-center justify-center" data-id="element-695">
                <MonitorSmartphoneIcon className="w-8 h-8 text-gray-600" data-id="element-696" />
              </div>
              <div data-id="element-697">
                <h3 className="text-2xl font-bold mb-3 text-gray-800 font-serif" data-id="element-698">
                  EPA Mobile App
                </h3>
                <p className="text-gray-600 mb-5 font-light" data-id="element-699">
                  Exclusive access to the EPA mobile app, included in your
                  membership package, connecting you with resources and the
                  community on the go.
                </p>
                <ul className="space-y-3 text-sm" data-id="element-700">
                  <li className="flex items-start" data-id="element-701">
                    <span className="inline-block w-5 h-5 bg-gray-100 rounded-full flex items-center justify-center mr-3 mt-0.5 shrink-0" data-id="element-702">
                      <span className="block w-2 h-2 bg-gray-600 rounded-full" data-id="element-703"></span>
                    </span>
                    <span className="text-gray-700" data-id="element-704">
                      On-the-go resource access
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-705">
                    <span className="inline-block w-5 h-5 bg-gray-100 rounded-full flex items-center justify-center mr-3 mt-0.5 shrink-0" data-id="element-706">
                      <span className="block w-2 h-2 bg-gray-600 rounded-full" data-id="element-707"></span>
                    </span>
                    <span className="text-gray-700" data-id="element-708">Community messaging</span>
                  </li>
                  <li className="flex items-start" data-id="element-709">
                    <span className="inline-block w-5 h-5 bg-gray-100 rounded-full flex items-center justify-center mr-3 mt-0.5 shrink-0" data-id="element-710">
                      <span className="block w-2 h-2 bg-gray-600 rounded-full" data-id="element-711"></span>
                    </span>
                    <span className="text-gray-700" data-id="element-712">Mobile booking tools</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* AI Concierge Card */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden transform transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl flex flex-col h-full" data-id="element-713">
            <div className="p-8 flex items-start gap-6" data-id="element-714">
              <div className="shrink-0 w-16 h-16 bg-gray-100 rounded-xl flex items-center justify-center" data-id="element-715">
                <MessageSquareIcon className="w-8 h-8 text-gray-600" data-id="element-716" />
              </div>
              <div data-id="element-717">
                <h3 className="text-2xl font-bold mb-3 text-gray-800 font-serif" data-id="element-718">
                  Wedding AI Concierge Bot
                </h3>
                <p className="text-gray-600 mb-5 font-light" data-id="element-719">
                  An intelligent WhatsApp AI bot that helps planners run
                  weddings with automated support, upsells, and customized
                  wedding workflows for guests.
                </p>
                <ul className="space-y-3 text-sm" data-id="element-720">
                  <li className="flex items-start" data-id="element-721">
                    <span className="inline-block w-5 h-5 bg-gray-100 rounded-full flex items-center justify-center mr-3 mt-0.5 shrink-0" data-id="element-722">
                      <span className="block w-2 h-2 bg-gray-600 rounded-full" data-id="element-723"></span>
                    </span>
                    <span className="text-gray-700" data-id="element-724">
                      24/7 guest support automation
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-725">
                    <span className="inline-block w-5 h-5 bg-gray-100 rounded-full flex items-center justify-center mr-3 mt-0.5 shrink-0" data-id="element-726">
                      <span className="block w-2 h-2 bg-gray-600 rounded-full" data-id="element-727"></span>
                    </span>
                    <span className="text-gray-700" data-id="element-728">
                      Personalized upsell opportunities
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-729">
                    <span className="inline-block w-5 h-5 bg-gray-100 rounded-full flex items-center justify-center mr-3 mt-0.5 shrink-0" data-id="element-730">
                      <span className="block w-2 h-2 bg-gray-600 rounded-full" data-id="element-731"></span>
                    </span>
                    <span className="text-gray-700" data-id="element-732">
                      Custom guest communication flows
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* RateBrain Card */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden transform transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl flex flex-col h-full" data-id="element-733">
            <div className="p-8 flex items-start gap-6" data-id="element-734">
              <div className="shrink-0 w-16 h-16 bg-gray-100 rounded-xl flex items-center justify-center" data-id="element-735">
                <BarChart4Icon className="w-8 h-8 text-gray-600" data-id="element-736" />
              </div>
              <div data-id="element-737">
                <h3 className="text-2xl font-bold mb-3 text-gray-800 font-serif" data-id="element-738">
                  RateBrain
                </h3>
                <p className="text-gray-600 mb-5 font-light" data-id="element-739">
                  Advanced analytics tool that helps you optimize pricing and
                  maximize profitability for every event.
                </p>
                <ul className="space-y-3 text-sm" data-id="element-740">
                  <li className="flex items-start" data-id="element-741">
                    <span className="inline-block w-5 h-5 bg-gray-100 rounded-full flex items-center justify-center mr-3 mt-0.5 shrink-0" data-id="element-742">
                      <span className="block w-2 h-2 bg-gray-600 rounded-full" data-id="element-743"></span>
                    </span>
                    <span className="text-gray-700" data-id="element-744">
                      Dynamic pricing models
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-745">
                    <span className="inline-block w-5 h-5 bg-gray-100 rounded-full flex items-center justify-center mr-3 mt-0.5 shrink-0" data-id="element-746">
                      <span className="block w-2 h-2 bg-gray-600 rounded-full" data-id="element-747"></span>
                    </span>
                    <span className="text-gray-700" data-id="element-748">
                      Market rate comparisons
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-749">
                    <span className="inline-block w-5 h-5 bg-gray-100 rounded-full flex items-center justify-center mr-3 mt-0.5 shrink-0" data-id="element-750">
                      <span className="block w-2 h-2 bg-gray-600 rounded-full" data-id="element-751"></span>
                    </span>
                    <span className="text-gray-700" data-id="element-752">
                      Profit optimization insights
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* Planner Dashboard Card */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden transform transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl flex flex-col h-full" data-id="element-753">
            <div className="p-8 flex items-start gap-6" data-id="element-754">
              <div className="shrink-0 w-16 h-16 bg-gray-100 rounded-xl flex items-center justify-center" data-id="element-755">
                <LayoutDashboardIcon className="w-8 h-8 text-gray-600" data-id="element-756" />
              </div>
              <div data-id="element-757">
                <h3 className="text-2xl font-bold mb-3 text-gray-800 font-serif" data-id="element-758">
                  Planner Dashboard
                </h3>
                <p className="text-gray-600 mb-5 font-light" data-id="element-759">
                  Comprehensive dashboard to manage all your events, clients,
                  vendors, and commissions in one place.
                </p>
                <ul className="space-y-3 text-sm" data-id="element-760">
                  <li className="flex items-start" data-id="element-761">
                    <span className="inline-block w-5 h-5 bg-gray-100 rounded-full flex items-center justify-center mr-3 mt-0.5 shrink-0" data-id="element-762">
                      <span className="block w-2 h-2 bg-gray-600 rounded-full" data-id="element-763"></span>
                    </span>
                    <span className="text-gray-700" data-id="element-764">
                      Client management system
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-765">
                    <span className="inline-block w-5 h-5 bg-gray-100 rounded-full flex items-center justify-center mr-3 mt-0.5 shrink-0" data-id="element-766">
                      <span className="block w-2 h-2 bg-gray-600 rounded-full" data-id="element-767"></span>
                    </span>
                    <span className="text-gray-700" data-id="element-768">
                      Vendor database integration
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-769">
                    <span className="inline-block w-5 h-5 bg-gray-100 rounded-full flex items-center justify-center mr-3 mt-0.5 shrink-0" data-id="element-770">
                      <span className="block w-2 h-2 bg-gray-600 rounded-full" data-id="element-771"></span>
                    </span>
                    <span className="text-gray-700" data-id="element-772">Commission tracking</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-773">
          <a href="#perks" className="inline-flex items-center text-limestone-700 hover:text-limestone-800 font-medium group" data-id="element-774">
            <span className="font-serif" data-id="element-775">Explore member perks</span>
            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-776">
              <line x1="5" y1="12" x2="19" y2="12" data-id="element-777"></line>
              <polyline points="12 5 19 12 12 19" data-id="element-778"></polyline>
            </svg>
          </a>
        </div>
      </div>
    </section>;
};